import React from 'react';

import { Container, Text, Link } from './ScheduleCTA.styled';
import { Patient } from 'kb-shared';
import { pageUrl } from 'utilities/pageUrl';

export const ScheduleCTA = ({ patient }: { patient: Patient }) => {
  return patient.gender === 'male' ? (
    <Container>
      <Text>
        If you are interested in discussing your at-home test results and your fertility options
        with a Kindbody Male Fertility Specialist, please schedule a virtual Hormone Panel
        Consultation. We will work with you to complete a detailed assessment and a male fertility
        evaluation.
      </Text>
      <Link href={pageUrl.booking.index({ step: 'location', appointmentId: 318 })}>Schedule</Link>
    </Container>
  ) : (
    <Container>
      <Text>
        If you are interested in discussing your at-home test results and your fertility options
        with a Kindbody provider, please schedule a fertility assessment. You will have a 1:1
        consultation with a fertility specialist and personalized plan for your next step.
      </Text>
      <Link href={pageUrl.booking.bookingQuiz({ type: 'answer', id: 274 })}>Schedule</Link>
    </Container>
  );
};
